module.exports = __webpack_public_path__ + "static/img/green_staking_discount_coupon.044238ac.png";